import { Box } from '@mui/material';
import SearchResultItem from './search-result-item.component';
import { UnderlyingsSearchResponse } from '@oai-frontend-monorepo/api';

interface Props {
  results?: UnderlyingsSearchResponse[];
  onSelect?: (symbol: string) => void;
}

const SearchResults = ({ results, onSelect }: Props) => {
  return (
    <Box position="absolute" top={0} left={0} bgcolor="#fff" width="100%">
      {results?.map((result) => (
        <SearchResultItem
          key={result.symbol}
          result={result}
          onSelect={onSelect}
        />
      ))}
    </Box>
  );
};

export default SearchResults;
